/**
 * Created with IntelliJ IDEA.
 *
 */
define(function (require) {
    "use strict";

    var Logger = require("logger");
    var Backbone = require("backbone");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var BatchelorModel = BaseModel.extend({
        resource:  ApiResources.Batchelor.BatchelorNew,
        name: "BatchelorModel",

        fetch: function(options) {
            var _options = _.extend(options, {
                data: _.values(this.toJSON()), //array of objects
                type: "POST",
                contentType: "application/json"
            });

            BaseModel.prototype.fetch.call(this, _options);
        }
    });

    return BatchelorModel;
});
